import React from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    Button,
    Table,
    Badge
} from "reactstrap";

const AssetsLiabilitiesList = ({ records = [], onAddNew, formatAmount, onRefresh, isLoading = false, onDelete, onEdit }) => {
    const renderActionButtons = (record) => (
        <span>
            <Button
                color="light"
                size="sm"
                className="mr-2 rounded-pill"
                onClick={() => onEdit(record)}
            >
                <i className="fa fa-edit text-primary"></i>
            </Button>
            <Button
                color="light"
                size="sm"
                className="rounded-pill"
                onClick={() => onDelete(record)}
            >
                <i className="fa fa-trash text-danger"></i>
            </Button>
        </span>
    );


    const renderFileIcon = (filePath) => {
        if (!filePath) return <span className="text-muted">—</span>;
        return (
            <Button
                color="link"
                className="p-0"
                title="View Document"
                style={{ fontSize: '1.4rem', color: '#007bff' }}
                onClick={e => {
                    e.stopPropagation();
                    window.open('#', '_blank'); // Replace '#' with actual file URL logic later
                }}
            >
                <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
            </Button>
        );
    };

    const renderTypeBadge = (type) => (
        <Badge
            color={type === 'ASSET' ? 'success' : 'warning'}
            pill
        >
            {type}
        </Badge>
    );
    return (
        <Card className="shadow-sm">
            <CardHeader style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                padding: "15px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "none"
            }}>
                <div>
                    <h5 className="m-0 font-weight-bold" style={{ color: "#fff" }}>
                        <i className="fa fa-balance-scale" style={{ marginRight: "10px" }}></i>
                        Assets and Liabilities
                    </h5>
                    <small style={{ color: "rgba(255,255,255,0.8)" }}>Manage your financial records</small>
                </div>
                <div className="d-flex">
                    <Button
                        className="px-4 mr-2 d-flex align-items-center"
                        onClick={onRefresh}
                        disabled={isLoading}
                        style={{
                            background: "rgba(255,255,255,0.2)",
                            border: "1px solid rgba(255,255,255,0.3)",
                            color: "#fff",
                            borderRadius: "8px"
                        }}
                    >
                        <i className={`fa fa-refresh mr-2 ${isLoading ? 'fa-spin' : ''}`}></i>
                        Refresh
                    </Button>
                    <Button
                        className="px-4 d-flex align-items-center"
                        onClick={onAddNew}
                        style={{
                            background: "#fff",
                            color: "#667eea",
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: "600"
                        }}
                    >
                        <i className="fa fa-plus mr-2"></i>
                        Add New Record
                    </Button>
                </div>
            </CardHeader>
            <CardBody className="p-0">
                <div className="table-responsive">
                    <Table hover bordered={false} className="mb-0">
                        <thead>
                            <tr style={{
                                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                            }}>
                                <th style={{ color: "#fff", border: "none", fontWeight: 600 }}>Type</th>
                                <th style={{ color: "#fff", border: "none", fontWeight: 600 }}>Name</th>
                                <th style={{ color: "#fff", border: "none", fontWeight: 600 }}>Description</th>
                                <th style={{ color: "#fff", border: "none", fontWeight: 600 }}>Category</th>
                                <th style={{ color: "#fff", border: "none", fontWeight: 600 }}>Amount</th>
                                <th style={{ color: "#fff", border: "none", fontWeight: 600 }}>Location</th>
                                <th style={{ color: "#fff", border: "none", fontWeight: 600 }}>Document</th>
                                <th style={{ color: "#fff", border: "none", fontWeight: 600 }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center py-4 text-muted">
                                        No records found
                                    </td>
                                </tr>
                            ) : (
                                records.map((record) => (
                                    <tr key={record.recordId}>
                                        <td>{renderTypeBadge(record.recordType)}</td>
                                        <td className="font-weight-bold">{record.name}</td>
                                        <td className="text-muted">{record.description || '-'}</td>
                                        <td className="text-muted">{(record && record.category && record.category.category) ? record.category.category : '-'}</td>
                                        <td className="font-weight-bold text-primary">
                                            {formatAmount(record.amount)}
                                        </td>
                                        <td>{record.location || '-'}</td>
                                        <td>{renderFileIcon(record.filePath)}</td>
                                        <td>{renderActionButtons(record)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </CardBody>
        </Card>
    );
};

export default AssetsLiabilitiesList;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/AssetsLiabilitiesList.js